import { Box, Flex, SvgIcon } from '@volue/wave-react';
import React from 'react';

import type { EvaluatedResult } from '@/features/execute-calculation-set/overmind/calculation/evaluation/EvaluatedResult';

export function EvaluatedValue(props: {
  status: EvaluatedResult<any>['status'];
  value: string;
}) {
  return (
    <>
      {/* // There is a need to have two boxes to make the test passing (could not check wave styles using testing-react-library) */}
      {props.status === 'ATTENTION_REQUIRED' ? (
        <Box
          data-testid="highlighted_box"
          className="dIB"
          css={{ color: '$colorRed100', fontWeight: 'bolder ' }}
        >
          {props.value}
        </Box>
      ) : props.status === 'ATTENTION_SUGGESTED' ? (
        <Box
          data-testid="warning_box"
          className="dIB"
          css={{ color: '$colorOrange70', fontWeight: 'bolder ' }}
        >
          {props.value}
        </Box>
      ) : (
        <Box className="dIB">{props.value}</Box>
      )}
    </>
  );
}

export function EvaluatedCalculationResult(props: {
  value: string;
  label: string;
  status: EvaluatedResult<any>['status'];
}) {
  return (
    <>
      <Flex main={'space-between'}>
        <Box data-testid="loadflow-mv-busbar-voltage-header">
          <SvgIcon iconName="minus" className="mRm" />
          {props.label}
        </Box>
        <EvaluatedValue status={props.status} value={props.value} />
      </Flex>
    </>
  );
}
